<template>
  <div class="ProjectInfo">
    <ComBox title="参建单位" :element="element">
      <div class="info" :style="`font-size: ${changeDevicePixelRatio(element.style.fontSize)}px;`">
        <div
          v-for="(item,index) in companyObject"
          v-show="index<4"
          :key="item.companyId"
          class="wrapping1"
        >
          <div class="label ellipsis">{{ item.companyTypeName }}</div>
          <div class="txt">{{ item.companyName }}</div>
        </div>
      </div>
    </ComBox>
  </div>
</template>

<script>
import ComBox from '../ComBox.vue'
import { mapState } from 'vuex'
import { companyData } from '@/api/screen'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
export default {
  components: { ComBox },
  props: {
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      companyObject: []
    }
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem,
      timeLog: state => state.socket.timeLog
    })
  },

  created() {
    this.companyData()
  },

  methods: {
    changeDevicePixelRatio,
    companyData() {
      companyData({ projectId: this.projectItem.projectId }).then(res => {
        this.companyObject = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ProjectInfo {
  width: 380px;
  height: 180px;
  overflow: hidden;
  .info{
    margin-top: 4%;
    .wrapping1{
        display: flex;
        font-family: SourceHanSansCN;
        margin-right: 5%;
        line-height: 2;
        padding-left: 4%;
        .label{
            width: 30%;
            flex-shrink: 0;
        }
        .txt{
          width: 66%;
          margin-left: 4%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }

    }
  }
}
</style>
